import React from "react";
import PageHeader from "@/components/PageHeader";
import { COMPANY } from "@/data/site";
import Seo from "@/components/Seo";

const SECTIONS = [
  {
    h: "Scope of this policy",
    p: "This Privacy Policy applies to both the VOLTECH POWER SOLUTIONS website (voltechpowersolutions.in) and the VOLTECH POWER SOLUTIONS mobile application available on Google Play. It explains what information we collect, how we use it, and the choices you have.",
  },
  {
    h: "Information we collect — Website",
    p: "When you submit our enquiry form, we collect your name, email address, phone number, company name (optional), service of interest and the message you send. We do not collect any other personal data via this website.",
  },
  {
    h: "Information we collect — Mobile App",
    p: "In the VOLTECH POWER SOLUTIONS mobile app we collect: (1) your Name, Email and Phone number for account creation and login via OTP; (2) service records and battery photos that you or our technicians upload for repair tracking. This information is used to operate your account and provide the service-booking and repair-tracking features of the app.",
  },
  {
    h: "Payments (Mobile App)",
    p: "Payments made in the mobile app are processed securely by Razorpay, our third-party payment gateway. We do NOT store your card, UPI or bank details on our servers — these are handled directly by Razorpay under their own security and compliance standards.",
  },
  {
    h: "How we use your information",
    p: `We use the information you provide to respond to enquiries, create and secure your app account, process service bookings, track repairs, deliver order/service updates and provide customer support. Website enquiries are routed to ${COMPANY.email}. We do not use your data for third-party advertising.`,
  },
  {
    h: "Storage & retention",
    p: "Enquiry data, account information, service records and uploaded photos are stored in our secured business systems. We retain records only as long as is reasonably necessary to serve you and to meet our statutory & GST record-keeping obligations, after which records are anonymised or deleted.",
  },
  {
    h: "Account & data deletion",
    p: `You can delete your account and associated data at any time directly from the app's Profile page, or by emailing us at ${COMPANY.email}. On request, we will delete your personal data (except records we are legally required to retain) within a reasonable time.`,
  },
  {
    h: "Third-party services",
    p: "We rely on the following trusted third parties: Razorpay (payment processing for the mobile app), Resend (transactional email for website enquiries), Google Maps (embedded maps) and Google Analytics 4 (anonymous website usage analytics). Each processes data under its own privacy policy. We do not sell, rent or share your information with marketers.",
  },
  {
    h: "Cookies & permissions",
    p: "The website uses minimal essential cookies for session management and no third-party advertising cookies. The mobile app may request camera/photo permissions solely to let you attach battery/service photos for repair tracking; you can decline or revoke these permissions in your device settings.",
  },
  {
    h: "Your rights",
    p: `You may request access to, correction of, or deletion of your data by writing to ${COMPANY.email}, or by using the in-app account deletion option. We will respond within a reasonable time.`,
  },
  {
    h: "Updates to this policy",
    p: "We may update this policy from time to time. The current version is always available on this page with the latest revision date below.",
  },
  {
    h: "Contact",
    p: `For any privacy-related questions, contact us at ${COMPANY.email} or at ${COMPANY.address}.`,
  },
];

export default function Privacy() {
  return (
    <div data-testid="page-privacy">
      <Seo
        path="/privacy"
        title="Privacy Policy"
        description="How VOLTECH POWER SOLUTIONS collects, uses and protects information shared through our website and mobile app, including payments (Razorpay) and account deletion."
      />
      <PageHeader
        eyebrow="Legal"
        title="Privacy Policy"
        subtitle={`How VOLTECH POWER SOLUTIONS collects, uses and protects information shared through our website and mobile app.`}
        testId="privacy-page-header"
      />
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500" data-testid="privacy-effective-date">
            Last updated · December 2025
          </div>
          <div className="mt-10 space-y-10">
            {SECTIONS.map((s, i) => (
              <div key={i} data-testid={`privacy-section-${i}`}>
                <h2 className="font-display text-xl md:text-2xl uppercase tracking-tight">
                  {s.h}
                </h2>
                <div className="red-accent-line mt-3" />
                <p className="text-zinc-300 mt-5 leading-relaxed text-[15px]">
                  {s.p}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
